import React from 'react';
import { Panel } from '@creditflowresearch/uilib/PanelGroup';
import IconExpand from '@creditflowresearch/uilib/Icon/IconExpand';
import IconCollapse from '@creditflowresearch/uilib/Icon/IconCollapse';

import styles from './faqPanel.module.scss';

export interface IFaqItemProps {
  hash: string,
  question: string,
  answer: React.ReactNode,
}

const FaqItem = ({ hash, question, answer }: IFaqItemProps) => (
  <Panel
    dataTest={ hash }
    id={ hash }
    header={ question }
    arrow={ <IconExpand /> }
    arrowActive={ <IconCollapse /> }
    className={ styles.faqPanelItem }
    activeClass={ styles.faqActivePanelItem }
    headerClass={ styles.faqPanelItemHeader }
    arrowWrapperClass={ styles.faqPanelItemArrow }
    contentClass={ styles.faqPanelItemContent }
  >
    { answer }
  </Panel>
);

export default FaqItem;
